import { mdiClockEditOutline } from "@mdi/js"
import { WORK_ORDER_ACTION_TOOLTIP_CLASS } from "../../../../../../../_logic/components-work-orders-action-tooltips"
import type { PlanningPreviewRow } from "../../../../../_shared/_logic/table-contract"
import type { TableRowAction } from "@kontextwerk/web-sdk/core/layout/table"
type Props = {
  row: PlanningPreviewRow
  disabled?: boolean
  onEdit: (row: PlanningPreviewRow) => Promise<void> | void
}
export default function buildRowActions({
  row,
  disabled = false,
  onEdit,
}: Props): TableRowAction[] {
  const actions: TableRowAction[] = []

  actions.push({
    id: "action-0",

    label: "Ansprechpartner-Verfügbarkeit bearbeiten",
    onClick: () => {
      onEdit(row)
    },
    icon: mdiClockEditOutline,
    disabled: disabled,
    tooltip: "Ansprechpartner-Verfügbarkeit bearbeiten",
  })

  return actions
}
